<template>
    <div class="cooperative-school">
        <el-form ref="form" :model="form" :inline="true" size="mini">
            <el-form-item label="姓名">
                <el-input v-model="form.realname" clearable placeholder="请输入用户名" style="width: 200px"
                    @keyup.enter.native="search"></el-input>
            </el-form-item>
            <el-form-item label="账号">
                <el-input v-model="form.name" clearable placeholder="请输入用户名" style="width: 200px"
                    @keyup.enter.native="search"></el-input>
            </el-form-item>

            <el-form-item>
                <el-button @click="search" type="primary">查询</el-button>
            </el-form-item>
        </el-form>
        <el-table size="mini" :data="tableData" :header-cell-style="{ background: '#f5f7fa' }">
            <el-table-column prop="realname" label="姓名">
                <template slot-scope="scope">{{ scope.row.studentUserInfo.realname }}</template>
            </el-table-column>
            <el-table-column prop="name" label="账号">
            </el-table-column>
            <el-table-column label="有效期">

                <template slot-scope="scope">
                    <span v-if="scope.row.enddate" style="color: #e6a23c;">
                        {{ scope.row.enddate.slice(0, 10) }}
                        <span v-if="new Date().getTime() - new Date(scope.row.enddate).getTime() >= 0">(已到期)</span>
                    </span>
                    <span style="color: #e6a23c;" v-else>未设置有效期</span>
                </template>
            </el-table-column>
            <el-table-column prop="schoolName" label="所在校区"></el-table-column>

        </el-table>
        <div class="pagination-style">
            <el-pagination @current-change="handleCurrentChange" :current-page.sync="page_no" :page-size="page_size"
                layout="total, prev, pager, next" :total="total"></el-pagination>
        </div>

    </div>
</template>

<script>
import {
    adminGetStudentList
} from "@/api/admin";


export default {

    data() {
        return {
            form: {
                realname: '',
                name: ''
            },
            tableData: [],
            total: 0,
            page_no: 1,
            page_size: 20

        }
    },
    mounted() {
        this.adminGetStudentList()

    },
    methods: {
        search() {
            this.page_no = 1;
            this.adminGetStudentList()
        },
        adminGetStudentList() {
            adminGetStudentList({
                realname: this.form.realname,
                name: this.form.name,
                page_no: this.page_no,
                page_size: this.page_size
            }).then((res) => {
                this.tableData = res.studentList
                this.total = res.total
                console.log(res)
            })
        },
        handleCurrentChange(val) {
            this.page_no = val;
            this.adminGetStudentList();
        }
    }

};
</script>

<style lang="scss" scoped>
.cooperative-school {
    padding: 20px;
    margin: 10px;
    background-color: #fff;
    border-radius: 5px;

    .form-style {
        margin-left: 15px;
    }

    .btn {
        margin-top: 15px;
    }
}
</style>